// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function DeleteMultipleMarketsRequestFromJSON(json) {
    return {
        'marketIds': !exists(json, 'marketIds') ? undefined : json['marketIds'],
    };
}
export function DeleteMultipleMarketsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'marketIds': value.marketIds,
    };
}
